import { FC, Fragment } from 'react';

const isLocalDev = process.env.NODE_ENV === 'development';

export const Static: FC = () => (
  <Fragment>
    {!isLocalDev && (
      <link rel="manifest" href="/static/assets/favicon/manifest.json" />
    )}
    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
    <meta name="theme-color" content="#ffffff" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@JLandPartners" />
    <meta
      name="apple-itunes-app"
      content="app-id=486502369, app-argument=m.johnlewis.com"
    />
    <meta name="mobile-web-app-capable" content="yes" />

    <link
      rel="shortcut icon"
      type="image/x-icon"
      href="https://www.johnlewis.com/static/assets/favicon/favicon.ico"
    />
    <link
      rel="icon"
      type="image/svg+xml"
      href="https://www.johnlewis.com/static/assets/favicon.svg"
    />
    <link
      rel="apple-touch-icon"
      href="https://www.johnlewis.com/static/assets/favicon/apple-touch-icon.png"
    />
  </Fragment>
);
